<template>
  <div class="w-full">
    <info-panel class="my-4 relative gateway-column-content">
      <template slot="content">
        <div class="w-full h-full rounded-t-lg relative">
          <div
            v-if="usesTextLogo"
            class="h-48 w-full flex items-center justify-center text-2xl font-bold text-grey-800"
          >
            {{ gatewayLabel }}
          </div>
          <div
            v-else
            class="bg-contain bg-no-repeat bg-center h-48 w-full"
            :style="{ backgroundImage: `url(${gatewayLogo})` }"
          ></div>
        </div>
      </template>
      <template slot="footer">
        <div class="flex w-full pl-4 justify-between items-center">
          <div class="flex flex-col items-center justify-center w-full">
            <div class="flex flex-col justify-left w-full">
              <p class="text-sm">{{ gatewayName }}</p>
            </div>
          </div>
          <drop-menu :menu-items="menuItems" small></drop-menu>
        </div>
      </template>
    </info-panel>
  </div>
</template>

<script>
import { COMMAS_DISPLAY_NAME } from './commas-integration-form';

export default {
  name: 'GrooveAccountGatewayAsset',

  props: {
    gatewayIntegration: {
      type: Object,
      required: true
    }
  },

  computed: {
    usesTextLogo() {
      return ['commas', 'increase_billing'].includes(
        this.gatewayIntegration.platform
      );
    },

    gatewayLabel() {
      return this.gatewayIntegration.platform === 'increase_billing'
        ? 'Increase'
        : COMMAS_DISPLAY_NAME;
    },

    gatewayName() {
      return this.gatewayIntegration.platform === 'commas'
        ? COMMAS_DISPLAY_NAME
        : this.gatewayIntegration.name;
    },

    gatewayLogo() {
      return `https://assets.grooveapps.com/payment-gateway/${this.gatewayIntegration.platform}-integration.png`;
    },

    menuItems() {
      return [
        {
          text: this.$t('frontend_groovesell_reporting_overide'),
          callback: () =>
            this.$emit(
              'onProcessingFeeClick',
              this.gatewayIntegration.id
            )
        }
      ];
    }
  }
};
</script>

<style scoped>
.gateway-column-content {
  width: 270px !important;
  height: 270px !important;
}
</style>
